var render = function render(){var _vm=this,_c=_vm._self._c;return _c('document-link',{staticClass:"pretty-route-link has-hover-background",attrs:{"document":_vm.route}},[_c('pretty-route',{attrs:{"route":_vm.route,"hide-activities":_vm.hideActivities,"hide-area":_vm.hideArea,"hide-orientation":_vm.hideOrientation,"hide-height-difficulties":_vm.hideHeightDiffDifficulties}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }